"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Overlay = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _nanoid = require("../utils/nanoid");
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _useOnClickOutside = require("../utils/_useOnClickOutside");
var _Popper = require("../utils/_Popper");
var _useFocusManager = require("../utils/useFocusManager");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Overlay = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Overlay.css") : void 0);
var _excluded = ["arrowClassName", "children", "className", "customContainerRef", "disableEdgeDetection", "disableFocusManager", "disableHideWhenTargetIsHidden", "disablePortal", "toggleOverlay", "flipContainer", "focusManagerProps", "focusRef", "hideShadow", "id", "innerDialogClassName", "maxWidth", "offset", "popperContentProps", "popperMiddleware", "popperPlacement", "popperProps", "renderTargetComponent", "show", "showArrow", "skidding", "skipTargetModifications", "targetClassName", "targetComponent", "targetProps", "width", "widthSizingType", "widthSizingTargetRef", "onClickOutside", "onEscapeKey", "onHide", "onKeyDown", "onShow", "ignoreStacking"],
  _excluded2 = ["className"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-overlay';

/**
 * Overlay is a generic popover-like component that can be used to render
 * content not typically available in the DOM. The Overlay content can be
 * rendered and shown on either click or hover events and be focus trapped
 * like an HTML dialog.
 */
var Overlay = exports.Overlay = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _width$trim;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Overlay, _props)) : _props;
  var arrowClassName = props.arrowClassName,
    children = props.children,
    className = props.className,
    customContainerRef = props.customContainerRef,
    disableEdgeDetection = props.disableEdgeDetection,
    disableFocusManager = props.disableFocusManager,
    disableHideWhenTargetIsHidden = props.disableHideWhenTargetIsHidden,
    disablePortal = props.disablePortal,
    toggleOverlay = props.toggleOverlay,
    flipContainer = props.flipContainer,
    focusManagerProps = props.focusManagerProps,
    focusRef = props.focusRef,
    hideShadow = props.hideShadow,
    id = props.id,
    innerDialogClassName = props.innerDialogClassName,
    maxWidth = props.maxWidth,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 1 : _props$offset,
    _props$popperContentP = props.popperContentProps,
    popperContentProps = _props$popperContentP === void 0 ? {} : _props$popperContentP,
    popperMiddleware = props.popperMiddleware,
    _props$popperPlacemen = props.popperPlacement,
    popperPlacement = _props$popperPlacemen === void 0 ? ['bottom-start', 'top-start', 'bottom-end', 'top-end', 'auto'] : _props$popperPlacemen,
    _props$popperProps = props.popperProps,
    popperProps = _props$popperProps === void 0 ? {} : _props$popperProps,
    renderTargetComponent = props.renderTargetComponent,
    _props$show = props.show,
    showProp = _props$show === void 0 ? false : _props$show,
    showArrow = props.showArrow,
    skidding = props.skidding,
    skipTargetModifications = props.skipTargetModifications,
    targetClassName = props.targetClassName,
    targetComponent = props.targetComponent,
    targetProps = props.targetProps,
    width = props.width,
    _props$widthSizingTyp = props.widthSizingType,
    widthSizingType = _props$widthSizingTyp === void 0 ? 'none' : _props$widthSizingTyp,
    widthSizingTargetRef = props.widthSizingTargetRef,
    showOnClickOutside = props.onClickOutside,
    _onEscapeKey = props.onEscapeKey,
    onHide = props.onHide,
    onKeyDown = props.onKeyDown,
    onShow = props.onShow,
    ignoreStacking = props.ignoreStacking,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var _useState = (0, _react.useState)(showProp),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var popoverRef = (0, _react.useRef)(null);
  var internalTargetRef = (0, _react.useRef)(null);
  var classnames = _bind.default.bind(_Overlay.default);
  var generatedId = (0, _nanoid.generate)();
  if (id) generatedId = id;
  var _id = (0, _react.useRef)(generatedId);
  var handleClickOutside = function handleClickOutside(event) {
    var _document, _document$querySelect, _popoverRef$current, _popoverRef$current$g, _overlays$0$getAttrib, _overlays$;
    var target = event.target;

    // if there are multiple overlays and we are processing the click
    // for the first overlay, let's skip it so the other overlays
    // can handle it.
    var overlays = (_document = document) === null || _document === void 0 || (_document$querySelect = _document.querySelectorAll) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.call(_document, 'div[data-overlay]');
    if (!ignoreStacking && overlays.length > 1 && ((_popoverRef$current = popoverRef.current) === null || _popoverRef$current === void 0 || (_popoverRef$current$g = _popoverRef$current.getAttribute) === null || _popoverRef$current$g === void 0 ? void 0 : _popoverRef$current$g.call(_popoverRef$current, 'data-overlay')) === ((_overlays$0$getAttrib = (_overlays$ = overlays[0]).getAttribute) === null || _overlays$0$getAttrib === void 0 ? void 0 : _overlays$0$getAttrib.call(_overlays$, 'data-overlay'))) {
      return;
    }
    var targetIsOutside;
    var targetIsTrigger;
    if (typeof target !== 'undefined') {
      var _popoverRef$current2, _popoverRef$current2$, _internalTargetRef$cu, _internalTargetRef$cu2;
      targetIsOutside = !(popoverRef !== null && popoverRef !== void 0 && (_popoverRef$current2 = popoverRef.current) !== null && _popoverRef$current2 !== void 0 && (_popoverRef$current2$ = _popoverRef$current2.contains) !== null && _popoverRef$current2$ !== void 0 && _popoverRef$current2$.call(_popoverRef$current2, target));
      targetIsTrigger = !!(target === (internalTargetRef === null || internalTargetRef === void 0 ? void 0 : internalTargetRef.current) || internalTargetRef !== null && internalTargetRef !== void 0 && (_internalTargetRef$cu = internalTargetRef.current) !== null && _internalTargetRef$cu !== void 0 && (_internalTargetRef$cu2 = _internalTargetRef$cu.contains) !== null && _internalTargetRef$cu2 !== void 0 && _internalTargetRef$cu2.call(_internalTargetRef$cu, target));
    }
    if (!targetIsOutside || targetIsTrigger) {
      // don't close if inside clicked or target clicked
      return;
    }
    // let user decide
    var userShows = !!(showOnClickOutside !== null && showOnClickOutside !== void 0 && showOnClickOutside(event));
    if (popoverRef !== null && popoverRef !== void 0 && popoverRef.current) {
      setShow(userShows);
    }
  };
  (0, _useOnClickOutside.useOnClickOutside)({
    ref: popoverRef,
    handleClickOutside: handleClickOutside,
    show: show
  });
  (0, _useFocusManager.useFocusManager)(_objectSpread({
    firstFocusIndex: 0
  }, focusManagerProps), !disableFocusManager && show, popoverRef);
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(function () {
    if (show) {
      onShow === null || onShow === void 0 || onShow();
    } else {
      onHide === null || onHide === void 0 || onHide();
    }
  }, [show]);

  // map props to state
  (0, _react.useEffect)(function () {
    setShow(showProp);
  }, [showProp]);
  var popperClassName = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--custom-size"), !!width), "".concat(CSS_BLOCK, "--arrow"), !hideShadow && showArrow), "".concat(CSS_BLOCK, "--no-shadow"), hideShadow));
  var target;
  if (targetComponent) {
    var _targetComponent$prop, _targetComponent$prop4;
    target = skipTargetModifications ? /*#__PURE__*/_react.default.cloneElement(targetComponent, {
      ref: (0, _reactMergeRefs.default)([targetComponent === null || targetComponent === void 0 ? void 0 : targetComponent.ref, internalTargetRef])
    }) : /*#__PURE__*/_react.default.cloneElement(targetComponent, {
      'aria-controls': show ? _id.current : null,
      'aria-expanded': show,
      'aria-haspopup': (targetComponent === null || targetComponent === void 0 || (_targetComponent$prop = targetComponent.props) === null || _targetComponent$prop === void 0 ? void 0 : _targetComponent$prop['aria-haspopup']) || 'dialog',
      onClick: (0, _chainFunction.default)(function () {
        var _targetComponent$prop2, _targetComponent$prop3;
        if ((toggleOverlay || !show) && !(targetComponent !== null && targetComponent !== void 0 && (_targetComponent$prop2 = targetComponent.props) !== null && _targetComponent$prop2 !== void 0 && _targetComponent$prop2.disabled) && !(targetComponent !== null && targetComponent !== void 0 && (_targetComponent$prop3 = targetComponent.props) !== null && _targetComponent$prop3 !== void 0 && _targetComponent$prop3.readOnly)) {
          setShow(!show);
        }
      }, targetComponent === null || targetComponent === void 0 || (_targetComponent$prop4 = targetComponent.props) === null || _targetComponent$prop4 === void 0 ? void 0 : _targetComponent$prop4.onClick),
      ref: (0, _reactMergeRefs.default)([targetComponent === null || targetComponent === void 0 ? void 0 : targetComponent.ref, internalTargetRef])
    });
  }

  // this is a workaround to allow targetComponents wrapped in Tooltips to
  // work. With the above target modifications, the props and ref would be
  // passed to the tooltip's wrapping div, not the actual target component.
  var adjustedRenderTargetComponent = renderTargetComponent;
  if (renderTargetComponent) {
    adjustedRenderTargetComponent = function adjustedRenderTargetComponent(passedTargetRef, referenceProps, targetClasses, additionalProps) {
      var mergedRefs = (0, _reactMergeRefs.default)([passedTargetRef, internalTargetRef]);
      var adjustedProps = _objectSpread(_objectSpread({}, additionalProps), {}, {
        onClick: (0, _chainFunction.default)(function () {
          if ((!show && !toggleOverlay || toggleOverlay) && !(additionalProps !== null && additionalProps !== void 0 && additionalProps.disabled) && !(additionalProps !== null && additionalProps !== void 0 && additionalProps.readOnly)) {
            setShow(!show);
          }
        }, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.onClick)
      });
      return renderTargetComponent(mergedRefs, referenceProps, targetClasses, adjustedProps);
    };
  }
  var _ref = popperContentProps || {},
    popperContentClassName = _ref.className,
    otherPopperContentProps = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
  var popperStyleProps = popperProps === null || popperProps === void 0 ? void 0 : popperProps.style;
  if (width !== null && width !== void 0 && (_width$trim = (0, _trim.default)(width)) !== null && _width$trim !== void 0 && _width$trim.call(width)) {
    popperStyleProps = _objectSpread(_objectSpread({}, popperStyleProps), {}, {
      width: width
    });
  }
  var extendedPopperProps = _objectSpread(_objectSpread(_objectSpread({
    'data-testid': _id.current,
    id: _id.current,
    role: 'dialog'
  }, otherProps), popperProps), {}, {
    innerRef: (0, _reactMergeRefs.default)([ref, popperProps === null || popperProps === void 0 ? void 0 : popperProps.innerRef]),
    style: popperStyleProps
  });
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    arrowClassName: classnames("".concat(CSS_BLOCK, "__arrow"), arrowClassName),
    disableHideWhenTargetIsHidden: disableHideWhenTargetIsHidden,
    flipContainer: flipContainer,
    offset: offset,
    onEscapeKey: function onEscapeKey(event) {
      var _internalTargetRef$cu3, _internalTargetRef$cu4, _focusRef$current, _focusRef$current$foc;
      setShow(false);
      internalTargetRef === null || internalTargetRef === void 0 || (_internalTargetRef$cu3 = internalTargetRef.current) === null || _internalTargetRef$cu3 === void 0 || (_internalTargetRef$cu4 = _internalTargetRef$cu3.focus) === null || _internalTargetRef$cu4 === void 0 || _internalTargetRef$cu4.call(_internalTargetRef$cu3);
      focusRef === null || focusRef === void 0 || (_focusRef$current = focusRef.current) === null || _focusRef$current === void 0 || (_focusRef$current$foc = _focusRef$current.focus) === null || _focusRef$current$foc === void 0 || _focusRef$current$foc.call(_focusRef$current);
      _onEscapeKey === null || _onEscapeKey === void 0 || _onEscapeKey(event);
    },
    maxWidth: maxWidth,
    popperClassName: popperClassName,
    popperContentProps: _objectSpread(_objectSpread({}, otherPopperContentProps), {}, {
      className: classnames("".concat(CSS_BLOCK, "__wrapper"), popperContentClassName)
    }),
    popperMiddleware: popperMiddleware,
    popperPlacement: popperPlacement,
    popperProps: extendedPopperProps,
    renderTargetComponent: adjustedRenderTargetComponent,
    show: children && show,
    showArrow: showArrow,
    targetClassName: targetClassName,
    targetComponent: target,
    targetProps: _objectSpread(_objectSpread({}, targetProps), {}, {
      'data-overlay-wrapper': true
    }),
    widthSizingType: widthSizingType,
    widthSizingTargetRef: widthSizingTargetRef,
    skidding: skidding,
    onKeyDown: onKeyDown,
    disablePopperContainer: disablePortal,
    disableEdgeDetection: disableEdgeDetection,
    customContainer: customContainerRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-overlay": _id.current,
    ref: popoverRef,
    className: classnames("".concat(CSS_BLOCK, "__dialog"), innerDialogClassName)
  }, children));
});
Overlay.displayName = 'Overlay';
Overlay.propTypes = {
  /**
   * Overlay contents as a React node.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Additional classes for the Overlay's arrow.
   */
  arrowClassName: _propTypes.default.string,
  /**
   * Additional classes for the Overlay's dialog.
   */
  className: _propTypes.default.string,
  /**
   * When `disablePortal` is **false** or unset,
   * use `customContainerRef` (set to a React reference) to render the Overlay dialog
   * in a custom DOM element that customContainerRef refers too.
   */
  customContainerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /**
   * Set to **true** to prevent the Overlay dialog
   * from flipping when it hits the `Overlay.flipContainer`
   * boundary. If unset, the Overlay will try to
   * flip around and position itself where space is available.
   */
  disableEdgeDetection: _propTypes.default.bool,
  /**
   * For an accessible keyboard experience,
   * the Overlay component manages focus by:
   *
   * * setting focus to first focusable element on open
   * * keeping focus trapped within the Overlay when open
   *
   * Set to **true** to disable this behavior and implement
   * your own.
   * */
  disableFocusManager: _propTypes.default.bool,
  /**
   * Set to **true** to show the Overlay's dialog
   * even when the target is out-of-view, for example
   * when user scrolls away too far.
   */
  disableHideWhenTargetIsHidden: _propTypes.default.bool,
  /**
   * Set to **true** to render the Overlay dialog
   * after its target in the DOM. If unset,
   * a React.Portal is used to render this dialog
   * as the last child of BODY in the DOM.
   */
  disablePortal: _propTypes.default.bool,
  /** Used to create a boundary for the underlying Popper to stay within
   * by flipping.
   */
  flipContainer: _CustomPropTypes.default.elementOrArrayOfElements(),
  /**
   * Set to **true** to hide CSS box-shadows
   * on the Overlay's dialog.
   * */
  hideShadow: _propTypes.default.bool,
  /**
   * By default, the Overlay remains open on consecutive clicks to the target.
   * Set to **true** to toggle the Overlay.
   * */
  toggleOverlay: _propTypes.default.bool,
  /**
   * ID for the Overlay's dialog.
   * Used for accessibility binding.
   * A generated value will be used
   * if unset.
   */
  id: _propTypes.default.string,
  /** Additional classes for the Overlay's inner dialog. */
  innerDialogClassName: _propTypes.default.string,
  /**
   * Numerical maxWidth for the Overlay dialog.
   * Number is converted to pixel.
   */
  maxWidth: _propTypes.default.number,
  /**
   * Numerical offset for displacing the Overlay
   * relative to its position, away from the target.
   * Number is converted to pixel.
   */
  offset: _propTypes.default.number,
  /**
   * Additional props to spread to the Overlay's
   * dialog's content DIV.
   */
  popperContentProps: _propTypes.default.object,
  /** Placement of the Overlay dialog relative to its target element.
   * Options are `'top'`, `'top-start'`, `'top-end'`, `'bottom'`, `'bottom-start'`,
   * `'bottom-end'`, `'left'`, `'left-start'`, `'left-end'`, `'right'`,
   * `'right-start'`, `'right-end'`.
   */
  popperPlacement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)), _propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)]),
  /**
   * Additional props to spread to the Overlay's
   * dialog.
   */
  popperProps: _propTypes.default.object,
  /**
   * Set to **true** to show the Overlay's dialog.
   */
  show: _propTypes.default.bool,
  /**
   * Set to **true** to show an arrow pointing
   * to the Overlay's target/trigger.
   * */
  showArrow: _propTypes.default.bool,
  /**
   * Additional classes for the Overlay's
   * target wrapper DIV.
   */
  targetClassName: _propTypes.default.string,
  /**
   * Overlay trigger as a React node.
   * A `<Button />` is recommended.
   */
  targetComponent: _propTypes.default.node,
  /**
   * Render prop to provide callback function for rendering
   * target component.  Function will be passed ref from
   * the Popper render function so it can be applied to
   * any node.
   */
  renderTargetComponent: _propTypes.default.func,
  /**
   * Additional props to spread to the Overlay's
   * target wrapper DIV.
   */
  targetProps: _propTypes.default.object,
  /**
   * The custom width of the Overlay's dialog.
   * The value must specify the units as well as
   * the value (e.g. `200px`, `40vw` or `30%`).
   * When a custom width is used, the
   * dialog receives a maximum height and content
   * within the popover will scroll,
   * if necessary.
   * */
  width: _propTypes.default.string,
  /**
   * The width of the Overlay dialog relative to the target.
   *
   * * `none`: Overlay width will be equal to content width.
   * * `matchTarget`: Overlay width will always be equal to size of the target.
   * * `minTarget`: Overlay width will be more than or equal to size of the target.
   * * `maxTarget`: Overlay width will be less than or equal to size of the target.
   *  */
  widthSizingType: _propTypes.default.oneOf(_Popper.POPPER_WIDTH_SIZING),
  /** @ignore set internally only. */
  ignoreStacking: _propTypes.default.bool,
  /** @ignore set internally only. */
  widthSizingTargetRef: _propTypes.default.any,
  /** @ignore set internally one. */
  focusManagerProps: _propTypes.default.object,
  /** @ignore set internally only. */
  popperMiddleware: _propTypes.default.array,
  /** @ignore set internally only. */
  skidding: _propTypes.default.number,
  /** @ignore set internally only. */
  skipTargetModifications: _propTypes.default.bool,
  /** @ignore set internally only. */
  focusRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  /**
   * Callback function for when the Overlay closes.
   */
  onHide: _propTypes.default.func,
  /**
   * Callback function for when the Overlay opens.
   */
  onShow: _propTypes.default.func,
  /**
   * Callback function for ESC keydown event
   * encountered inside the Overlay.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * */
  onEscapeKey: _propTypes.default.func,
  /**
   * Callback function for keydown events
   * encountered inside the Overlay.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * */
  onKeyDown: _propTypes.default.func,
  /**
   * Callback function for a
   * click event encountered on an element
   * that is outside the Overlay but is
   * not the Overlay target. Its return value will be
   * converted to a boolean and used to determine if
   * the dialog should be shown in such an event.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {Boolean} - returning `true` will NOT hide the Overlay dialog
   */
  onClickOutside: _propTypes.default.func
};
var _default = exports.default = Overlay;